import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: solid 10px ${(props) => props.color};
  min-height: 500px;
`;

export const Inner = styled.div`
  padding: 25px 0 20px 18px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;
